import { render, staticRenderFns } from "./person-center.vue?vue&type=template&id=710ebabf&scoped=true&"
import script from "./person-center.vue?vue&type=script&lang=js&"
export * from "./person-center.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710ebabf",
  null
  
)

export default component.exports